import component from './social-media.component';

export default angular
  .module('fizyweb.paycell.socialMedia', [])
  .component('socialMedia', component).name;



// WEBPACK FOOTER //
// src/app/components/social-media/social-media.module.ts